<template>
  <v-card class="mt-4">
    <div>
      <v-card-title><strong>Alterar Senha</strong><br /></v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-progress-linear :active="carregando" class="ma-0" color="cyan accent-3" height="3" indeterminate></v-progress-linear>

        <v-form ref="formAlterar" v-model="alterarValid" lazy-validation class="mt-4">
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex offset-xs2 xs8 offset-md4 md4>
                <v-text-field
                  :disabled="isUpdating"
                  background-color="white"
                  v-model="senhaAtual"
                  label="Senha atual"
                  maxlength="20"
                  :type="showSenhaAtual ? 'text' : 'password'"
                  :append-icon="showSenhaAtual ? 'visibility' : 'visibility_off'"
                  @click:append="showSenhaAtual = !showSenhaAtual"
                  hint="Obrigatório"
                  :rules="[
                    validacao.senhaAtual == false || validacao.senhaAtual,
                    (value) => !!value || 'Obrigatório.',
                    (value) => (value && value.length > 5) || 'Mínimo: 6 dígitos'
                  ]"
                  autocomplete="disabled"
                  :name="Math.random()"
                  @change="validacao.senhaAtual = false"
                ></v-text-field>
              </v-flex>
              <v-flex offset-xs2 xs8 offset-md4 md4>
                <v-text-field
                  :disabled="isUpdating"
                  background-color="white"
                  v-model="novaSenha"
                  label="Nova senha"
                  maxlength="20"
                  :type="showNovaSenha ? 'text' : 'password'"
                  :append-icon="showNovaSenha ? 'visibility' : 'visibility_off'"
                  @click:append="showNovaSenha = !showNovaSenha"
                  hint="Obrigatório"
                  :rules="[
                    validacao.novaSenha == false || validacao.novaSenha,
                    (value) => !!value || 'Obrigatório.',
                    (value) => (value && value.length > 7) || 'Mínimo: 8 dígitos'
                  ]"
                  autocomplete="disabled"
                  :name="Math.random()"
                  @change="validacao.novaSenha = false"
                ></v-text-field>
              </v-flex>
              <v-flex offset-xs2 xs8 offset-md4 md4>
                <v-text-field
                  :disabled="isUpdating"
                  background-color="white"
                  v-model="repetirSenha"
                  label="Repetir nova senha"
                  maxlength="20"
                  :type="showRepetirSenha ? 'text' : 'password'"
                  :append-icon="showRepetirSenha ? 'visibility' : 'visibility_off'"
                  @click:append="showRepetirSenha = !showRepetirSenha"
                  hint="Obrigatório"
                  :rules="
                    (validacao.repetirSenha == false || validacao.repetirSenha, [(value) => !!value || 'Obrigatório.', (value) => value == novaSenha || 'Repita a nova senha'])
                  "
                  autocomplete="disabled"
                  :name="Math.random()"
                  @change="validacao.repetirSenha = false"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
              </v-flex>
              <v-flex xs12 class="text-center">
                <v-btn :disabled="isUpdating" class="primary" large @click="alterar">Alterar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../util";
export default {
  data() {
    return {
      senhaAtual: null,
      novaSenha: null,
      repetirSenha: null,

      validacao: {
        senhaAtual: false,
        novaSenha: false,
        repetirSenha: false,
        mensagemErro: false
      },

      alterarValid: true,
      showSenhaAtual: false,
      showNovaSenha: false,
      showRepetirSenha: false,

      isUpdating: false,
      carregando: true
    };
  },
  methods: {
    async alterar() {
      this.isUpdating = true;
      try {
        await util.limparObjeto(this.validacao, false);

        if (!this.$refs.formAlterar.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        var body = {
          senhaAtual: this.senhaAtual,
          novaSenha: this.novaSenha
        };

        //* Registra a nova senha
        await api.put("/ass/paywall/alterar-senha", body);

        await this.$store.dispatch("deslogarUsuario");
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
      }
    }
  },
  async created() {
    do {
      await util.delay(1000);
    } while (!this.$store.state.site.enderecoSite);
    document.title = this.$store.state.site.nome;

    this.carregando = false;
  }
};
</script>
